import { createSelector } from '@reduxjs/toolkit';

export const addUserSlice = (state) => state.addUser;

export const selectAllUsers = createSelector([addUserSlice], (slice) => slice.allUsers);
export const selectSelectedUser = createSelector([addUserSlice], (slice) => slice.selectedUser);

export const selectUsers = createSelector([addUserSlice], (slice) => slice.allUsers);
export const selectUser = createSelector([addUserSlice], (slice) => slice.selectedUser);
export const selectedUserRoles = createSelector([addUserSlice], (slice) => slice.selectedUserRoles);
export const selectedUserRole = createSelector([addUserSlice], (slice) => slice.selectedUserRole);

export const selectUserErrors = createSelector([addUserSlice], (slice) => slice.submittingFormError);

export const selectPeopleFormStatus = createSelector([addUserSlice], (slice) => slice.formStatus);
export const selectAuthTypeFormstatus = createSelector([addUserSlice], (slice) => slice.authTypeFormStatus);

export const selectRemoveAuthTypePopupVisible = createSelector([addUserSlice], (slice) => slice.removeAuthTypePopupVisible);
export const selectAddAuthTypePopupVisible = createSelector([addUserSlice], (slice) => slice.addAuthTypePopupVisible);

export const selectAddPopupVisible = createSelector([addUserSlice], (slice) => slice.addPopupVisible);

export const selectPersonList = createSelector([addUserSlice], (slice) => slice.personList);

export const selectMasterList = createSelector([addUserSlice], (slice) => slice.masterList);
export const selectMasterItem = createSelector([addUserSlice], (slice) => slice.selectedMasterList);
export const selectCompanyState = createSelector([addUserSlice], (slice) => slice.companyState);

export const selectAuthTypeList = createSelector([addUserSlice], (slice) => slice.authTypeList);
export const selectSelectedAuthType = createSelector([addUserSlice], (slice) => slice.selectedAuthType);

export const selectSubmittingFormInProgress = createSelector([addUserSlice], (slice) => slice.submittingFormInProgress);
